var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethocope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B3954;}\n\t.st1{fill:#16ADE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.7,97.7l48.8,59.9c6.8,8.3,6.9,20,0.3,28.4l-73.5,94c1.8,1,3.5,2.2,5.1,3.5c2,1.7,3.9,3.6,5.4,5.8    l74-94.7c10.6-13.6,10.4-32.5-0.5-45.8l-48.8-59.9C294.4,92.3,290.8,95.3,286.7,97.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.4,294.2L155.4,294.2c-8.9,7.4-9.1,21-0.5,28.7c16.7,15,34.2,22.6,52,22.6c17.9,0,35.3-7.6,52-22.6     c8.6-7.7,8.4-21.3-0.5-28.7v0c-7.3-6.1-17.9-5.8-25,0.6c-9.4,8.5-18.3,12.7-26.6,12.7c-8.3,0-17.2-4.3-26.6-12.7     C173.3,288.4,162.7,288.1,155.4,294.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.4,283.4c1.6-1.3,3.3-2.5,5.1-3.5l-73.5-94c-6.6-8.4-6.5-20.1,0.3-28.4l48.8-59.9    c-4-2.4-7.7-5.4-10.8-8.8l-48.8,59.9c-10.9,13.4-11.1,32.3-0.5,45.8l74,94.7C142.6,287.1,144.4,285.1,146.4,283.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 150.4,
    cy: 58,
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 263.4,
    cy: 58,
    r: 32
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.4,387.3v30.2c0,33.9-27.6,61.4-61.4,61.4H168.7c-10.4,0-18.9-8.5-18.9-18.9V454h20.8    c25.3,0,46-20.6,46-46v-49.1c-3.2,0.4-6.4,0.6-9.6,0.6c-1.5,0-2.9,0-4.4-0.1V408c0,17.6-14.3,32-32,32h-20.8v-28.1    c0-10.8-4.2-20.9-11.8-28.6c-7.6-7.6-17.8-11.8-28.6-11.8c-22.3,0-40.4,18.1-40.4,40.4v1.7c0,22.3,18.1,40.4,40.4,40.4h26.4v6.1    c0,18.2,14.8,32.9,32.9,32.9H340c41.6,0,75.4-33.8,75.4-75.4v-30.2c-2.3,0.3-4.6,0.5-7,0.5C406.1,387.8,403.7,387.7,401.4,387.3z     M135.7,440h-26.4c-14.6,0-26.4-11.8-26.4-26.4v-1.7c0-14.6,11.8-26.4,26.4-26.4c7,0,13.7,2.8,18.7,7.7c5,5,7.7,11.6,7.7,18.7V440    z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.1,281.9c11.3-3.6,23.7-3.6,34.9,0.1c0.7,0.2,1.4,0.3,2.2,0.3c3,0,5.7-1.9,6.7-4.9    c1.2-3.7-0.8-7.6-4.5-8.8c-7-2.3-14.4-3.4-21.8-3.4c-7.4,0-14.6,1.1-21.6,3.3c-3.7,1.2-5.7,5.1-4.5,8.8    C383.4,281,387.4,283,391.1,281.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 408.4,
    cy: 336.5,
    r: 37.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.8,282c-0.1-0.4-0.2-0.9-0.4-1.3c-0.2-0.4-0.4-0.8-0.6-1.2c-0.3-0.4-0.6-0.7-0.9-1.1    c-0.3-0.3-0.7-0.6-1.1-0.9c-0.4-0.3-0.8-0.5-1.2-0.6c-0.4-0.2-0.9-0.3-1.3-0.4c-0.9-0.2-1.8-0.2-2.7,0c-0.5,0.1-0.9,0.2-1.3,0.4    c-0.4,0.2-0.8,0.4-1.2,0.6c-0.4,0.3-0.7,0.6-1.1,0.9c-0.3,0.3-0.6,0.7-0.9,1.1c-0.3,0.4-0.5,0.8-0.6,1.2c-0.2,0.4-0.3,0.9-0.4,1.3    c-0.1,0.5-0.1,0.9-0.1,1.4c0,1.9,0.8,3.7,2.1,5c0.3,0.3,0.7,0.6,1.1,0.9c0.4,0.3,0.8,0.5,1.2,0.6c0.4,0.2,0.9,0.3,1.3,0.4    c0.5,0.1,0.9,0.1,1.4,0.1c0.5,0,0.9,0,1.4-0.1c0.5-0.1,0.9-0.2,1.3-0.4c0.4-0.2,0.8-0.4,1.2-0.6c0.4-0.3,0.7-0.5,1.1-0.9    c1.3-1.3,2-3.1,2-5C451.9,282.9,451.9,282.4,451.8,282z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethocope);
export default __webpack_public_path__ + "static/media/stethocope.6ccba41a5d802e226f7c95f3234b6911.svg";
export { ForwardRef as ReactComponent };